import { BaseService } from '/@/modules/core/app/services/abstracts/BaseService';
import LightDiagnosticExternalResource, {
  LightDiagnosticExternalResource as LightDiagnosticResourceResourceClass
} from '@/modules/lightdiagnostic/resources/LightDiagnosticExternalResource';
import { LightDiagnosticCalculatePlanForm } from '@/modules/lightdiagnostic/models/LightDiagnosticCalculatePlanForm';

export class LightDiagnosticExternalService extends BaseService {
  resource: LightDiagnosticResourceResourceClass;

  constructor() {
    super();
    this.resource = LightDiagnosticExternalResource;
  }

  async calculateBillingPlan(params: Params = {}): Promise<LightDiagnosticCalculatePlanForm> {
    return LightDiagnosticCalculatePlanForm.mapModel(
      await this.resource.calculateBillingPlan(params)
    );
  }
}

export default new LightDiagnosticExternalService();
